import { render, staticRenderFns } from "./ProductField.vue?vue&type=template&id=16e05733"
import script from "./ProductField.vue?vue&type=script&lang=js"
export * from "./ProductField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports